var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-list"},[_c('UserSearch'),_c('hr'),_c('div',{staticStyle:{"text-align":"right"}},[_c('b-button',{attrs:{"variant":"primary","to":"new"}},[_vm._v("新規登録")])],1),_c('UserPager'),_c('UserTable'),_c('UserPager')],1)}
var staticRenderFns = []

export { render, staticRenderFns }